var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inventory
    ? _c(
        "div",
        [
          _c("ImageViewer", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.files.length,
                expression: "files.length"
              }
            ],
            attrs: { isShowDelete: _vm.canMediaDelete, medias: _vm.files },
            on: {
              "removed-media": function($event) {
                _vm.$toasted.info(_vm.$t("txtDeleted").toString())
              }
            }
          }),
          _vm._v(" "),
          _c("DropZone", {
            attrs: { formId: "inventoryEditDz" },
            on: { complete: _vm.onDzComplete }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }